import { ReactNode } from 'react';
import './style.scss';

export enum ButtonType {
  Submit = 'submit',
  Button = 'button',
}

export enum ButtonFill {
  white = 'button_white',
  black = 'button_black',
  primary = 'button_primary',
  link = 'button_link',
}

export enum ButtonSize {
  xsmall = 'button_xsmall',
  small = 'button_small',
  medium = 'button_medium',
  large = 'button_large',
  extraLarge = 'button_extraLarge',
}

type ButtonProps = {
  type?: ButtonType;
  label?: string;
  children?: ReactNode;
  buttonFill?: ButtonFill;
  buttonSize?: ButtonSize;
  disable?: boolean;
  onClick?: () => void;
};

export const Button = (props: ButtonProps) => {
  const { type, label, children, buttonFill, buttonSize, disable, onClick } = props;
  return (
    <button
      type={type ? type : ButtonType.Button}
      className={`button ${buttonFill} ${buttonSize}`}
      disabled={disable}
      onClick={onClick}
    >
      {label}
      {children}
    </button>
  );
};
